<div class="main-div plan-instructions ml-5">
  <p>Faça um PIX para <strong>00.106.244/0001-53 no valor de R$ 24,99 ou utilize o QRCode abaixo</strong>, na sequência
    faça um <strong>UPLOAD</strong> do comprovante em <strong>PDF</strong>. O sistema reconhecerá automaticamente o pagamento e liberará créditos para o MENTOR VIRTUAL. Bons estudos!
  </p>
  <img src="{{ qrCodeLink }}" alt="QRCode para pagamento com pix" width="226px" height="224px">
  <div class="plan-instructions-footer">
    <input type="file" accept=".pdf" (change)="fileChangeEvent($event)" />
    <button class="btn btn-primary mt-4 mb-3" type="button" (click)="upload()">UPLOAD do comprovante</button>
  </div>
</div>
